<ion-header translucent>
  <ion-toolbar color="primary" style="padding:0">
    <ion-title>{{title}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()"><ion-icon name="close-circle-outline"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content force-overscroll="false">
<ion-datetime color="primary" [locale]="locale"
  [showClearButton] = "true"
  [clearText]= "'Reset' | translate"
  #popoverDatetime
  [disabled]="disabled"
  [cancelText]="cancelText"
  [doneText]="doneText"
  [(ngModel)]="value"
  [presentation]="presentation"
  (ionChange)="value = formatDate(popoverDatetime.value)"
></ion-datetime>
</ion-content>